
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"ex-9---internationalization"}}>{`Ex. 9 - Internationalization`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"instructions"}}>{`Instructions`}</MDXTag>
<MDXTag name="p" components={components}>{`Nous souhaitons maintenant traduire notre application et donner la possibilité à l'utilisateur de changer la langue en live.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Créer un dossier `}<MDXTag name="inlineCode" components={components} parentName="li">{`src/locales`}</MDXTag>{` avec deux fichiers `}<MDXTag name="inlineCode" components={components} parentName="li">{`en.json`}</MDXTag>{` et `}<MDXTag name="inlineCode" components={components} parentName="li">{`fr.json`}</MDXTag>{` (voir aide)`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Créer un fichier `}<MDXTag name="inlineCode" components={components} parentName="li">{`src/components/I18n.js`}</MDXTag>{` qui exposera :`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`I18nProvider`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`useI18n`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`useT`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`T`}</MDXTag></MDXTag>
</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Ajouter `}<MDXTag name="inlineCode" components={components} parentName="li">{`I18nProvider`}</MDXTag>{` dans `}<MDXTag name="inlineCode" components={components} parentName="li">{`index.js`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Modifier `}<MDXTag name="inlineCode" components={components} parentName="li">{`SearchInput`}</MDXTag>{` afin de récupérer le placeholder via `}<MDXTag name="inlineCode" components={components} parentName="li">{`useT`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Modifier `}<MDXTag name="inlineCode" components={components} parentName="li">{`App`}</MDXTag>{` et ajouter un bouton pour changer la langue et traduire le titre de l'application`}</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"résultat-attendu"}}>{`Résultat attendu`}</MDXTag>
<MDXTag name="p" components={components}>{`Un bouton s'affiche me permettant de changer la langue de l'application.`}</MDXTag>
<iframe
  src="https://codesandbox.io/embed/github/smooth-code/react-hooks-workshop/tree/end-exercise-9/?fontsize=14&view=preview"
  style={{
    width: '100%',
    height: 500,
    border: 0,
    borderRadius: 4,
    overflow: 'hidden',
  }}
  sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
/>
<MDXTag name="h2" components={components} props={{"id":"aide"}}>{`Aide`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"i18njs"}}>{`I18n.js`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`// I18n.js
import React, { createContext, useState, useContext, useMemo } from 'react'

// Contexte I18n, il n'est pas directement exposé
const I18nContext = createContext()

// Provider permettant l'injection du contexte
export function I18nProvider({ translations, defaultLocale, children }) {
  // TODO: à l'aide de "useState", créer la valeur injectée dans le contexte.
  // Elle contiendra : \`translations\`, \`locale\` et \`setLocale\`.
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
}

// Hook permettant de récupérer une clef
export function useT(id) {
  // TODO: à l'aide de "useContext", récupérer la traduction correspondante à "id"
}

// Composant permettant de récupérer une clef
export function T({ id }) {
  return useT(id)
}

// Hook permettant de récupérer le contexte i18n
export function useI18n() {
  return useContext(I18nContext)
}
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"branchement-du-i18nprovider"}}>{`Branchement du I18nProvider`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`// index.js
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import Catch from './components/Catch'
import { I18nProvider } from './components/I18n'
import * as serviceWorker from './serviceWorker'
import en from './locales/en.json'
import fr from './locales/fr.json'

ReactDOM.render(
  <Catch>
    <I18nProvider translations={{ en, fr }} defaultLocale="en">
      <App />
    </I18nProvider>
  </Catch>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"locales"}}>{`Locales`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`en.json`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-json"}}>{`{
  "fr": "🇫🇷 French",
  "en": "🇬🇧 English",
  "title": "Smooth Movies",
  "placeholder": "Type something..."
}
`}</MDXTag></MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`fr.json`}</MDXTag></MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-json"}}>{`{
  "fr": "🇫🇷 Français",
  "en": "🇬🇧 Anglais",
  "title": "Smooth Films",
  "placeholder": "Tapez quelque chose..."
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  